module.exports = __webpack_public_path__ + "img/pay-item-1.a063689a.png";